import { render } from "./PolicyFix.vue?vue&type=template&id=c1b7518e&ts=true"
import script from "./PolicyFix.vue?vue&type=script&lang=ts"
export * from "./PolicyFix.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/PolicyFix.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c1b7518e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c1b7518e', __exports__)) {
    api.reload('c1b7518e', __exports__)
  }
  
  module.hot.accept("./PolicyFix.vue?vue&type=template&id=c1b7518e&ts=true", () => {
    api.rerender('c1b7518e', render)
  })

}


export default __exports__